import { CUSTOM_COLOR_SWATCHES, DISCO_COLOR } from './allocationCategories';

const STORAGE_KEY = 'rookoo:planning:recent-allocation-colors';
const MAX_RECENT_COLORS = 8;
const HEX_RE = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

const normalizeHex = value => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!HEX_RE.test(trimmed)) return null;
  return trimmed.toLowerCase();
};

const hasLocalStorage = () => {
  try {
    return typeof window !== 'undefined' && !!window.localStorage;
  } catch (_error) {
    return false;
  }
};

export const readRecentAllocationColors = () => {
  if (!hasLocalStorage()) return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.map(normalizeHex).filter(Boolean);
  } catch (_error) {
    return [];
  }
};

/**
 * Push a newly picked color to the front of the "recent" list, dedupe,
 * clamp length, and persist. Returns the updated list.
 */
export const pushRecentAllocationColor = color => {
  const hex = normalizeHex(color);
  if (!hex || hex === DISCO_COLOR) return readRecentAllocationColors();

  const defaults = new Set(CUSTOM_COLOR_SWATCHES.map(c => c.toLowerCase()));
  if (defaults.has(hex)) return readRecentAllocationColors();

  const existing = readRecentAllocationColors().filter(c => c !== hex);
  const next = [hex, ...existing].slice(0, MAX_RECENT_COLORS);

  if (hasLocalStorage()) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (_error) {
      // quota or disabled – ignore
    }
  }
  return next;
};
